<style scoped="scoped">
	*{
		margin: 0;
		padding: 0;
		box-sizing: border-box;
	}
  .otherManageBox{
    width:100%;
    height:auto;
    padding-top:30px;
  }
  .otherManageTop{
    height:30px;
    display: flex;
    align-items:center;
    width:100%;
    margin-bottom: 40px;
  }
  .otherManageIconBtn{
    height:30px;
    color:#363636;
    cursor: pointer;
    font-size: 16px;
    display: flex;
    align-items:center;
    line-height: 30px;
  }
  .otherManageIconBtn i{
    font-size: 25px;
    margin-right:5px;
  }
  .otherManageDelBtn{
    margin-left:40px;
  }
  .otherManageDelCancel{
    color:indianred;
    margin-left:15px;
    font-size: 16px;
    cursor: pointer;
    line-height: 30px;
  }
  .otherManageImport{
    display: flex;
    align-items: center;
    margin-left: 40px;
  }
  .otherManageImport .import-img{
    width: 25px;
    height: 25px;
    margin-right: 5px;
  }
  .otherManageImport .import-img img{
    display: block;
    width: 100%;
    height: 100%;
  }
  .otherManageBaseDataSetBtn{
    color:#5757fa;
    margin-left:40px;
    font-size: 13px;
    cursor: pointer;
    line-height: 30px;
  }
  .otherManageFilter{
    margin-left:65px;
    width:auto;
    height:30px;
    position: relative;
  }
  .otherManageFilter i{
    position: absolute;
    right:5px;
    top:0;
    line-height: 30px;
    font-size: 18px;
    cursor: pointer;
  }
  .otherManageFilter input{
    width:300px;
    height:30px;
    padding:0 15px;
    border-radius: 15px;
    border: 1px solid #939393;
    outline: none;
  }
</style>

<template>
    <div class='otherManageBox'>
      <div class='otherManageTop'>
         <div class='otherManageAddBtn otherManageIconBtn' @click="addProduct"><i class='el-icon-circle-plus-outline'></i>添加木门</div>
         <div class='otherManageDelBtn otherManageIconBtn' @click='deleteType=true' v-if='!deleteType'><i class='el-icon-delete'></i>删除</div>
         <div class='otherManageDelBtn otherManageIconBtn' @click='deleteConfirm' v-if='deleteType'><i class='el-icon-delete'></i>确认({{deleteCount}})</div>
         <div class='otherManageDelCancel' @click='deleteCancel' v-if='deleteType'>取消</div>
         <!-- <div class='otherManageBaseDataSetBtn' @click="dataSet">基础数据设置...</div> -->
         <div class='otherManageBaseDataSetBtn' @click="toStoreManage">库存管理</div>
         <div class='otherManageFilter'><input @keyup.enter="tableFilter" type="text" v-model='filter'><i @click='tableFilter' class='el-icon-search'/></div>
      </div>
      <listTable ref='woodenDoorTable' :deleteType='deleteType' @changeDeleteCount='changeDeleteCount'></listTable>
    </div>
</template>

<script>
  import listTable from './woodenDoorTable'
	export default {
		components:{
      listTable,
		},
		props:[],
		data() {
			return {
          filter:"",
          deleteType:false,
          deleteCount:0,
			}
		},
		computed: {

		},
		mounted() {

		},
		methods: {
      closeImport(val){
        this.show_plank_data = false;
        // 如果是导入后关闭弹框则重新请求数据, 如果只是点击空白处关闭, 则不会重新请求
        if(val){
          this.$refs.woodenDoorTable.getList()
        }
      },
      toStoreManage(){
          // this.$message('待开发')
        this.$router.push('storeManage')
      },
      refreshList(){
        this.$refs.plankTable.getList()
      },
      tableFilter(){
        this.$refs.woodenDoorTable.filter(this.filter)
      },
      deleteConfirm(){
        if(this.deleteCount!=0){
          this.$confirm('确认删除选中商品吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$refs.woodenDoorTable.deleteGoods()
            // 重新拉取商品列表
            // this.$refs.woodenDoorTable.getList()
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });
        }else{
          this.$message({
            type: 'info',
            message: '请选择想要删除的商品'
          });
        }

      },
      changeDeleteCount(count){
        this.deleteCount=count
      },
      deleteCancel(){
        this.deleteType=false
        this.$refs.woodenDoorTable.clearDelete()
      },
      addProduct(){
        this.$refs.woodenDoorTable.changeEdit('')
      },
      dataSet(){
        // console.log(111111)
        this.$emit('dataSet',true)
      }
		}
	}
</script>
